import { produce } from 'immer'
import type { State } from '../../typings'

export const closeActivitySummaryProducer = produce<State>((draft) => {
  draft.open = false
})
